import { useState } from 'react';

import axios from 'axios';
import i18n from 'i18next';

import getReplaceVideoSchema from '../schemas/getReplaceVideoSchema';
import getFullScreenFormModal from '../helpers/getFullScreenFormModal';
import getFileNameFromDirectUploadURL from '../helpers/getFileNameFromDirectUploadURL';
import handleAdminVideoAxiosError from '../helpers/handleAdminVideoAxiosError';

const onSaveButtonClick = async ({
  params,
  payload,
  queryClient,
  setIsReplacing,
  updateCache,
  videoVersion,
  videoVersionKey,
}) => {
  try {
    const versionId = videoVersion.data?.draft_id;
    const api =
      params.type === 'live'
        ? `live_videos/${params.id}/trailer${versionId ? `?version_id=${versionId}` : ''}`
        : `videos/${params.id}/replace_video${versionId ? `?version_id=${versionId}` : ''}`;

    const url = `/api/admin/${api}`;

    /* eslint-disable no-param-reassign */
    if (payload.video_source === 'url') {
      payload.url = payload.external_url;
      delete payload.external_url;
    } else {
      payload.video_file_name = getFileNameFromDirectUploadURL(payload.url);
    }
    /* eslint-enable no-param-reassign */

    setIsReplacing(true);
    const {
      data: { data },
    } = await axios.put(url, { data: payload });

    updateCache({
      ...data,
      ...(payload.video_source && { video_source: payload.video_source }),
    });

    queryClient.invalidateQueries(videoVersionKey);
  } catch (error) {
    handleAdminVideoAxiosError(error);
  } finally {
    setIsReplacing(false);
  }
};

const onReplaceVideoClick = async ({ titleKey, ...rest }) => {
  const title = i18n.t(titleKey);
  const schema = getReplaceVideoSchema();

  await getFullScreenFormModal({
    schema,
    title,
    onSaveButtonClick: ({ payload }) =>
      onSaveButtonClick({
        ...rest,
        payload,
      }),
  });
};

export default (args) => {
  const [isReplacing, setIsReplacing] = useState(false);

  return {
    isReplacing,
    onReplaceVideoClick: (titleKey) => onReplaceVideoClick({ ...args, setIsReplacing, titleKey }),
  };
};
